import { AppState } from '../redux/reducers';
import { trackError } from './tracking';
import getConfig from '../config';

const STORAGE_KEY = 'the_signup_flow';

export function persistState(state: Object): void {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ state, version: getConfig().version })
    );
  } catch (exception) {
    trackError(exception.toString());
    return;
  }
}

export function getPersistedState(): AppState {
  try {
    const rawPersistedState = sessionStorage.getItem(STORAGE_KEY);
    if (!rawPersistedState) {
      return undefined;
    }

    return JSON.parse(rawPersistedState).state;
  } catch (exception) {
    trackError(exception.toString());
    return undefined;
  }
}

export function clearPersistedState(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (exception) {
    trackError(exception.toString());
    return;
  }
}
